// extracted by mini-css-extract-plugin
export default {"simpleBtn":"SimpleBtn_simpleBtn__0RCXj","btnLink":"SimpleBtn_btnLink__SqCjo"};